import { Box } from "@mui/material";
import { ReactNode } from "react";
import PortalFooter from "../footer/portalFooter";

/**
 * The page column: the neutral page background, the page itself, and the
 * secured-by/support strip beneath it.
 *
 * A flex column with a minimum viewport height, so the footer sits at the
 * bottom of a short page and below the content of a long one -- the click
 * dummy's `.pf` shell -- instead of floating up under a thin page.
 */
const Body = ({ children }: { children: ReactNode; isHomePage?: boolean }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      bgcolor: "background.default",
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    <PortalFooter />
  </Box>
);

export default Body;
